import React from "react";
import Ourservices from "./OurServices";
import VrService from "./VrService";
import ArService from "./ArService";
import KidsGamesServices from "./KidsGamesServices";
import OtherGames from "./OtherGames";
import PickleBall from "./PickleBall";
import XrService from "./XrGames";
import CgiService from "./CgiService";
import bannervideo from "../assets/videos/bannervideo.mp4";
import './Common.css';
import './home.css';

const Home = () => {
    
    return (
        <>
                <div className="position-absolute m-0 p-0 h-100 w-100 top-0 zindex-minus-1">
                    <video className="h-100 w-100" autoPlay playsInline muted loop style={{objectFit:"cover", opacity:'0.1'}}>
                        <source type="video/mp4; codecs=&quot;avc1.4D401E, mp4a.40.2&quot;" src={bannervideo}></source>
                    </video>
                </div>
                <div className=" position-relative h-100 zindex-2">
                    <div className="row text-white d-flex justify-content-center align-items-center home-page-content h-100">
                        <div className="col-md-6 col-11 flex-end p-0 rounded-5 px-5">
                            <div className="gradient-video-border">
                                <video className="rounded-5 h-100 w-100" autoPlay playsInline muted loop style={{objectFit:"cover"}}>
                                    <source type="video/mp4; codecs=&quot;avc1.4D401E, mp4a.40.2&quot;" src="https://cdn.pixabay.com/video/2022/10/18/135385-761676447_large.mp4"></source>
                                </video>
                            </div>
                        </div>
                        <div className="col-md-6 col-11 flex-start px-5 slide-right">
                            <h1 className="display-4 fw-bolder gradient-text">Shri Hans Frolic Energy & Tech LLP</h1>
                            <p className="fs-4 fw-bold lead">At Shri Hans Frolic Energy & Tech LLP, we blend spirituality with innovation 
                            to deliver transformative solutions in energy, technology, and infrastructure. 
                            Our mission is to lead globally by creating sustainable projects that drive holistic 
                            progress and inspire positive change.</p>
                        </div>
                    </div>
                </div>
            

            <Ourservices></Ourservices>

            <VrService></VrService>

            <ArService></ArService>

            <KidsGamesServices></KidsGamesServices>
            <OtherGames></OtherGames>
            <PickleBall></PickleBall>
            <XrService></XrService>
            <CgiService></CgiService>
        </>
    )
}

export default Home;